export const GET_USERS_AND_ACCESS = `
  query getUsersAndAccess($year: Int!) {
    listUsers {
      Enabled
      UserStatus
      Username
      Attributes {
        Name
        Value
      }
    }
    listUserMapping(year: $year) {
      error {
        code
        message
        statusCode
      }
      data {
        Username
        id
        mappings {
            endDate
            startDate
            reference
            insertedDate
            isCurrent
            access {
              element1Id
              element2Id
              element3Id
              element4Id
            }
          }
      }
    }
  }
`
